import React from 'react';
import {BaseComponent as Component} from 'BaseComponent';
import Action from '../actions';
import {connect} from 'react-redux';

class RemoveLineup extends Component {
    onClick(lineupId) {
        this.props.dispatch(Action.do('removeLineup', lineupId));
    }

    render() {
        const {sportConfig, lineupId, className = '', children = null} = this.props;

        if (sportConfig.isModeLateswap()) {
            return null;
        }

        return (
            <a className={className} onClick={(e) => ::this.onClick(lineupId)}>
                {children}
            </a>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

export default connect(mapStatesToProps)(RemoveLineup);
